import {ControlledDatePicker} from 'components/hookForms';
import React from 'react';
import {Control} from 'react-hook-form';
import {useEditMatkonParagraphsFormTranslations} from '../../EditParagraphsForm/editParagraphsFormTranslationHooks';
import {
	MatkonSetLimitsType,
	MatkonFormLimitType,
	MatkonFormType,
	MatkonFormSetError,
	MatkonFormClearErrors,
} from '../MatkonTypes';

interface MatkonInternalEntryDatePickerProps {
	control: Control<MatkonFormType>;
	index: number;
	limit: MatkonFormLimitType;
	setLimits: MatkonSetLimitsType;
	setError: MatkonFormSetError;
	clearErrors: MatkonFormClearErrors;
	onDeleteClick: () => void;
}
export const MatkonInternalEntryDatePicker: React.FC<
	MatkonInternalEntryDatePickerProps
> = ({
	control,
	index,
	limit,
	setLimits,
	setError,
	clearErrors,
	onDeleteClick,
}) => {
	const {t} = useEditMatkonParagraphsFormTranslations();
	const validate = (date: any) => {
		if (limit.deadlineLaw && date > new Date(limit.deadlineLaw)) {
			setError(`limits.${index}.deadlineLaw`, {
				message: t('InternalAfterDeadlineLaw'),
			});
			return t('InternalAfterDeadlineLaw');
		}
		clearErrors(`limits.${index}.deadlineLaw`);
		return true;
	};

	const onChange = (date: any) => {
		setLimits(prevLimits => {
			const newLimits = [...prevLimits];
			newLimits[index].deadlineInternal =
				date instanceof Date ? date.toISOString() : '';
			return newLimits;
		});
	};

	const onDelete = () => {
		setLimits(prevLimits => {
			const newLimits = [...prevLimits];
			newLimits[index].deadlineInternal = undefined;
			return newLimits;
		});
		clearErrors(`limits.${index}.deadlineInternal`);
		clearErrors(`limits.${index}.deadlineLaw`);
		onDeleteClick();
	};

	return (
		<ControlledDatePicker
			control={control}
			name={`limits.${index}.deadlineInternal`}
			label={t('InternalEntryDate')}
			onChange={onChange}
			rules={{
				validate,
			}}
			actionTags={[
				{
					iconName: 'Cancel',
					onClick: onDelete,
				},
			]}
		/>
	);
};
